import { Card, CardContent } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { StyleHTMLAttributes } from 'react';

const styles = {
  card: {
    height: '98%',
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '2rem',
    justifyContent: 'space-around',
    height: '100%',
  },
};

export const LoadingCard = () => (
  <Card style={styles.card}>
    <CardContent>
      <div style={styles.cardContent as StyleHTMLAttributes<HTMLDivElement>}>
        <Skeleton animation="wave" variant="rect" style={{ width: '256px' }} />
        <Skeleton animation="wave" variant="rect" style={{ width: '80%' }} />
        <Skeleton animation="wave" variant="rect" style={{ width: '172px' }} />
      </div>
    </CardContent>
  </Card>
);
